// @flow
import * as React from 'react';
import { ButtonBase } from '@mui/material';
import { makeVar, useReactiveVar } from '@apollo/client';
import { useSavedSettings } from '../../shared';
import { useEffect } from 'react';

export const menuCollapsed = makeVar<boolean>(false);

export const MenuToggleButton = () => {
  const [savedSettings, setSavedSettings] = useSavedSettings();
  const collapsed = useReactiveVar(menuCollapsed);

  useEffect(() => {
    menuCollapsed(typeof savedSettings.menuCollapsed === 'undefined' ? false : savedSettings.menuCollapsed);
  }, [savedSettings.menuCollapsed]);

  const toggle = () => {
    setSavedSettings({
      menuCollapsed: !collapsed
    });
  }

  return (
    <ButtonBase sx={{position: 'absolute', top: 0, bottom: 0, right: 0, zIndex: 1, width: 10, cursor: 'w-resize'}}
                onMouseDown={toggle} />
  );
};
